import type { Route } from '!/router'
import * as root from '~/routes/catchups/root'

export const route: Route = {
  children: [
    {
      path: ['', '/:catchupId'],
      component: [root.Title, root.CatchupsPage],
      init: root.model.initCatchupPage,
      left: root.model.leftCatchupPage,
    },
    {
      path: [
        '/:catchupId/channel/:channelId',
        '/:catchupId/channel/:channelId/date/:timestamp',
      ],
      component: [root.Title, root.CatchupsPage],
      init: root.model.initCatchup,
      left: root.model.left,
      meta: {
        contentId(params: { channelId: string }) {
          return Number(params.channelId)
        },
      },
    },
  ],
}
